module.exports = __webpack_public_path__ + "static/media/E1_Sports_allmode.d61301ba.png";